import { render, staticRenderFns } from "./ModalAnaliseElegibilidadeResumoPY.vue?vue&type=template&id=fd98ab98&lang=pug"
import script from "./ModalAnaliseElegibilidadeResumoPY.vue?vue&type=script&lang=js"
export * from "./ModalAnaliseElegibilidadeResumoPY.vue?vue&type=script&lang=js"
import style0 from "./ModalAnaliseElegibilidadeResumoPY.vue?vue&type=style&index=0&id=fd98ab98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports